module.exports = __webpack_public_path__ + "static/media/medical-service-companies.ebca694d.jpg";